var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconUnmute(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 281.33 281.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M279.36,144.84,191.54,47.25V10.89a10.05,10.05,0,0,0-10-10H101.1a10.05,10.05,0,0,0-10,10.05V47.25L3.23,144.84a10,10,0,0,0,7.43,16.78H271.92a10.05,10.05,0,0,0,7.44-16.78ZM171.44,20.94V41H111.15V20.94ZM33.27,141.52l72.28-80.39H177l72.29,80.39Z",
    transform: "translate(-0.62 -0.84)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.56,248.74a10.07,10.07,0,0,0-15-13.47,80.41,80.41,0,0,1-127.12-8.94v0a9.95,9.95,0,1,0-16.37,11.27,100.49,100.49,0,0,0,158.47,11.16Z",
    transform: "translate(-0.62 -0.84)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.75,218.59a10.07,10.07,0,1,0-15-13.46,51,51,0,0,1-4,4,50.24,50.24,0,0,1-70.94-4,10.07,10.07,0,0,0-15,13.46,70.34,70.34,0,0,0,104.91,0Z",
    transform: "translate(-0.62 -0.84)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.44,188.45a10.07,10.07,0,0,0-15-13.47,20.1,20.1,0,0,1-30.15,0,10.15,10.15,0,0,0-15.17,13.47,40.19,40.19,0,0,0,60.29,0Z",
    transform: "translate(-0.62 -0.84)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUnmute);
export default __webpack_public_path__ + "static/media/icon-unmute.3928740829f7eb40493dc28ba56d6036.svg";
export { ForwardRef as ReactComponent };